/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Checkout_Reasons_Waiting1Inputs */

const vi_sitesettings_checkout_reasons_waiting1 = /** @type {(inputs: Sitesettings_Checkout_Reasons_Waiting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đang chờ xử lý`)
};

/**

* @param {Sitesettings_Checkout_Reasons_Waiting1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_checkout_reasons_waiting1 = /** @type {((inputs?: Sitesettings_Checkout_Reasons_Waiting1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Checkout_Reasons_Waiting1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_checkout_reasons_waiting1(inputs)
});
export { sitesettings_checkout_reasons_waiting1 as "siteSettings_checkout_reasons_waiting" }